import { Stack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { RoutesMap } from "../../../../routes.tsx";
import { AddCardInnerButton } from "./AddCardInnerButton.tsx";

interface Props {
  hideModal: () => void;
}

export function AddCardModal({ hideModal }: Props) {
  const navigate = useNavigate();

  const addCard = () => {
    hideModal();
    navigate(RoutesMap.cards.addCard);
  };

  const addSBP = () => {
    hideModal();
    navigate(RoutesMap.cards.addSbp);
  };

  return (
    <Stack spacing="11px" px="4px">
      <AddCardInnerButton title="Добавить карту" onClick={addCard} />
      <AddCardInnerButton title="Добавить СБП оплату" isSbp={true} onClick={addSBP} />
    </Stack>
  );
}
